import { TBrand } from "@type-defs/product/TBrand";
import { TProductCategory } from "@type-defs/product/TProductCategory";
import { TProductTag } from "@type-defs/product/TProductTag";
import { TUnit } from "@type-defs/unit/TUnit";

export const productPriceFields = ({
  secondarySalesTaxTypeValue,
  secondarySalesPriceValue,
  sameWithSecondary,
  setShowHistoryModal,
  secondarySalesTaxValue,

  primarySalesPriceValue,
  primarySalesTaxValue,
  primarySalesTaxTypeValue,
  directSalesTaxTypeValue,
  withHistory,
  directSalesPriceValue,
  directSalesTaxValue
}: {
  secondarySalesTaxTypeValue?: string; 
  secondarySalesPriceValue?: number;
  setShowHistoryModal?: any;
  primarySalesPriceValue?: number;
  primarySalesTaxValue?: number;
  primarySalesTaxTypeValue?: string;
  secondarySalesTaxValue?: number;
  sameWithSecondary?: boolean;
  directSalesTaxTypeValue?: string;
  directSalesPriceValue?: number;
  directSalesTaxValue?: number;
  withHistory?: {
    priceHistory?: boolean;
  };
}) => {
  return [
  
    // {
    //   name: "SALE PRICES",
    //   type: "secondary-title",
    // },
    {
      name: "primary_sales_price",
      type: "number",
      label: "Primary Sales Price",
      // withHistory: withHistory?.priceHistory,
      setShowHistoryModal: setShowHistoryModal,
      required: true,
      min: 0,
      defaultValue: 0,
    },

    {
      name: "primary_sales_tax",
      type: "number",
      label: "Primary Sales Tax",
      value: secondarySalesTaxValue,
      defaultValue: 0,
      min: 0,
    },
    {
      name: "primary_sales_tax_type",
      type: "select",
      label: "Primary Sales Tax Type",
      options: [
        {
          label: "Percentage",
          value: "%",
        },
        {
          label: "Amount",
          value: "AMT",
        },
      ],
      value: secondarySalesTaxTypeValue,
    },
    {
      name: "Custom Component",
      type: "custom-component",
    },
    {
      name: "secondary_sales_price",
      type: "number",
      label: "Secondary Sales Price",
      // withHistory: withHistory?.priceHistory,
      setShowHistoryModal: setShowHistoryModal,
      required: true,
      min: 0,
      defaultValue: 0,
    },

    {
      name: "secondary_sales_tax",
      type: "number",
      label: "Secondary Sales Tax",
      value: secondarySalesTaxValue,
      defaultValue: 0,
      min: 0,
    },
    {
      name: "secondary_sales_tax_type",
      type: "select",
      label: "Secondary Sales Tax Type",
      options: [
        {
          label: "Percentage",
          value: "%",
        },
        {
          label: "Amount",
          value: "AMT",
        },
      ],
      value: secondarySalesTaxTypeValue,
    },


     {
      name: "direct_sales_price",
      type: "number",
      label: "Direct Sales Price",
      // withHistory: withHistory?.priceHistory,
      setShowHistoryModal: setShowHistoryModal,
      required: true,
      min: 0,
      defaultValue: 0,
    },

    {
      name: "direct_sales_tax",
      type: "number",
      label: "Direct Sales Tax",
      value: directSalesTaxValue,
      defaultValue: 0,
      min: 0,
    },
    {
      name: "direct_sales_tax_type",
      type: "select",
      label: "Direct Sales Tax Type",
      options: [
        {
          label: "Percentage",
          value: "%",
        },
        {
          label: "Amount",
          value: "AMT",
        },
      ],
      value: directSalesTaxTypeValue,
    },
    
  
   
  ];
};
